import { useTranslation } from "react-i18next"
import { MarketingChannelEnum, type MarketingChannel } from "schema"

export function useMarketingChannelOptions() {
  const { t } = useTranslation()

  const channelLabels = {
    email: t("customers.filters.marketingChannel.email"),
    sms: t("customers.filters.marketingChannel.sms"),
    whatsapp: t("customers.filters.marketingChannel.whatsapp"),
  } satisfies Record<MarketingChannel, string>

  return Object.values(MarketingChannelEnum).map((channel) => ({
    value: channel,
    label: channelLabels[channel],
  }))
}
